export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9384.cefa73c3.jpg";